  if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      this.loadProductRecommendations();
    }

    loadProductRecommendations() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(html => {
          const responseDOMParser = new window.DOMParser();
          const responseDocument = responseDOMParser.parseFromString(html, 'text/html');
          const responseDocumentRecommendations = responseDocument.querySelector('product-recommendations');

          if (responseDocumentRecommendations && responseDocumentRecommendations.querySelectorAll('[data-product-recommendation]').length) {
            this.innerHTML = responseDocumentRecommendations.innerHTML;

            if (document.body.hasAttribute('data-animations-enabled')) {
              window.AOS.init({
                disable: 'mobile',
                once: true,
                offset: 200
              });
            }
          } else {
            this.classList.add('d-none');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}